import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2a666d2a&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=2a666d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a666d2a",
  null
  
)

export default component.exports